/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Offline_BannerInputs */



/**
* | output |
* | --- |
* | "Offline - Changes will sync when reconnected" |
*
* @param {Status_Offline_BannerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const status_offline_banner = /** @type {((inputs?: Status_Offline_BannerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Offline_BannerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hors ligne - Les modifications seront synchronisées lors de la reconnexion")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin conexión - Los cambios se sincronizarán al reconectar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Offline - As alterações serão sincronizadas quando reconectar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offline - Le modifiche saranno sincronizzate alla riconnessione")
	return /** @type {LocalizedString} */ ("Offline - Changes will sync when reconnected")
});